import React from "react";
import "./HowToBuySection.css";

import StyledMdText from "../../../common/components/styledMdText/StyledMdText";
import StyledH2Heading from "../../../common/components/styledH2Heading/StyledH2Heading";
import StyledH4Heading from "../../../common/components/styledH4Heading/StyledH4Heading";
import StyledH5Heading from "../../../common/components/styledH5Heading/StyledH5Heading";

const HowToBuySection = () => {
  const cardsStyle =
    "flex flex-col gap-5 xl:gap-14 2xl:gap-40 border-[3px] border-green rounded-xl p-5 sm:p-7 col-span-4 md:col-span-2 lg:col-span-2 xl:col-span-1 group";
  return (
    <div
      id="HowToBuySection"
      className="flex justify-center bg-white w-full 2xl:h-auto"
    >
      <div className="flex justify-center items-center gap-10 w-11/12 sm:w-[85%] py-10">
        <div className="grid grid-cols-4 xl:grid-cols-3 gap-y-5 gap-x-3">
          {/* Card 1 */}
          <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-5 md:gap-10 gradientBackground rounded-xl p-4 md:px-8 md:py-20 col-span-4 xl:col-span-2 group">
            <div className="space-y-2 w-11/12">
              <StyledH2Heading font="text-white">how to buy</StyledH2Heading>
              <StyledH5Heading font="text-white">
                How to buy is the best part of crypto platform, where the crypto
                adventure begins. Jaba the pepe is more than just a foundation
                of meme culture, utility and philanthropy.
              </StyledH5Heading>
            </div>
            <div className="w-[60%]">
              <img
                src="/assets/how-to-buy-frog.png"
                alt="Jaba the Pepe"
                className="w-full transition-transform duration-500 ease-in-out group-hover:scale-105"
              />
            </div>
          </div>

          {/* Card 2 */}
          <div className={cardsStyle}>
            <div className="w-full xl:h-[132px]">
              <img
                src="/assets/how-to-buy-frog-2.webp"
                alt="Jaba the Pepe"
                className="card-image w-1/2 max-w-[50%]"
              />
            </div>
            <div className="space-y-2">
              <StyledH4Heading font="textGradient">
                1.Create a Wallet
              </StyledH4Heading>
              <StyledMdText font="text-black">
                Download Phantom or your wallet of choice from the app store or
                google play store for free. Desktop users, download the google
                chrome extension by going to phantom app
              </StyledMdText>
            </div>
          </div>

          {/* Card 3 */}
          <div className={cardsStyle}>
            <div className="w-full xl:h-[132px]">
              <img
                src="/assets/how-to-buy-frog-3.webp"
                alt="Jaba the Pepe"
                className="card-image w-1/2 max-w-[50%]"
              />
            </div>
            <div className="space-y-2">
              <StyledH4Heading font="textGradient">
                2.Get some SOL
              </StyledH4Heading>
              <StyledMdText font="text-black">
                Have SOL in your wallet to switch to JEPE If you don’t have any
                SOL, you can buy SOL from an exchange or cross chain swap and
                send it to your wallet.
              </StyledMdText>
            </div>
          </div>

          {/* Card 4 */}
          <div className={cardsStyle}>
            <div className="w-full xl:h-[132px]">
              <img
                src="/assets/how-to-buy-frog-4.webp"
                alt="Jaba the Pepe"
                className="card-image w-1/2 max-w-[50%]"
              />
            </div>
            <div className="space-y-2">
              <StyledH4Heading font="textGradient">
                3.Go to Raydium
              </StyledH4Heading>
              <StyledMdText font="text-black">
                Connect to Raydium. Go raydium.io in google chrome or on the
                browser inside your Phantom app. Connect your wallet. Paste the
                jepe token address into Raydium and confirm the swap. When
                Phantom prompts you for a wallet signature, sign.
              </StyledMdText>
            </div>
          </div>

          {/* Card 5 */}
          <div className={cardsStyle}>
            <div className="w-full xl:h-[132px]">
              <img
                src="/assets/how-to-buy-frog-5.webp"
                alt="Jaba the Pepe"
                className="card-image w-1/2 max-w-[50%]"
              />
            </div>
            <div className="space-y-2">
              <StyledH4Heading font="textGradient">4.Swap</StyledH4Heading>
              <StyledMdText font="text-black">Switch SOL for jepe</StyledMdText>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowToBuySection;
